import './App.css';
import Container from 'react-bootstrap/Container'
import myimg from './assets/img/sarah.png'
import {Row, Col} from 'react-bootstrap'
import React, {useEffect} from 'react'
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Slider from './components/Slider/Slider';
import { Swiper, SwiperSlide } from 'swiper/react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from './Firebase';
import { Link } from 'react-router-dom';
import 'swiper/css/pagination';
import 'swiper/css';
import { Navigation, Pagination } from 'swiper/modules';
import { useState } from 'react';
import 'swiper/css/navigation';
import bg from './assets/img/app.png'
import salonLogo from './assets/img/sarahs.png'
import { services } from './Model/services';
import './screen/Home/Home.css';
import NewsSlide from './components/NewsSlide/NewsSlide';
import SEO from './components/SEO';

// Replace with your YouTube video ID (e.g. from https://www.youtube.com/watch?v=VIDEO_ID) or leave empty for placeholder
const FEATURED_VIDEO_ID = ''
const INSTAGRAM_PROFILE_URL = 'https://www.instagram.com/sarahadombraiding/'

function App() {
  const ctaStyle = {
    backgroundImage: `url(${bg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  };
  





  




  const [collections, setCollections] = useState([]);
  const [instagramPosts, setInstagramPosts] = useState([]);
  useEffect(() => {
    const fetchCollections = async () => {
      const collectionsRef = collection(db, 'Gallery');
      const snapshot = await getDocs(collectionsRef);

      const collectionList = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      setCollections(collectionList);
    };

    fetchCollections();












  }, []);

  useEffect(() => {
    const feedUrl = process.env.REACT_APP_INSTAGRAM_FEED_URL
    if (!feedUrl) return

    let mounted = true
    fetch(feedUrl)
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error('Feed request failed'))))
      .then((payload) => {
        if (!mounted) return
        const items = Array.isArray(payload) ? payload : payload?.data || []
        const normalized = items
          .map((item, idx) => ({
            id: item.id || `ig-${idx}`,
            mediaUrl: item.media_url || item.thumbnail_url || item.src || '',
            permalink: item.permalink || INSTAGRAM_PROFILE_URL,
            caption: item.caption || '',
          }))
          .filter((item) => item.mediaUrl)
        setInstagramPosts(normalized.slice(0, 6))
      })
      .catch(() => {
        // Silent fail: fallback is gallery content.
      })

    return () => {
      mounted = false
    }
  }, [])


  return (
    <>
    <SEO
      title="Home"
      description="Professional braiding salon in Manassas, VA. Explore services, gallery, reviews, and book your appointment."
      path="/"
    />
    <Slider />
    <div className="App home-page">
      <Container className="home-services-section home-services">
        <div className="home-section-head">
          <span className="section-label">What we do</span>
          <h3 className="our-heading">Our Services</h3>
          <p>Braiding, styling & more</p>
        </div>

        <Swiper
          spaceBetween={16}
          className="mySwiper home-swiper"
          modules={[Navigation, Pagination]}
          watchSlidesProgress
          pagination={{ clickable: true }}
          breakpoints={{
            0: { slidesPerView: 1 },
            400: { slidesPerView: 2 },
            639: { slidesPerView: 2 },
            865: { slidesPerView: 2 },
            1000: { slidesPerView: 4 },
            1500: { slidesPerView: 4 },
            1700: { slidesPerView: 4 },
          }}
        >
          {services.map((item, index) => (
            <SwiperSlide key={`${item.id}-${index}`}>
              <Card className="border-0 home-service-card">
                <div className="services-svg">{item.image}</div>
                <Card.Body>
                  <Card.Title>{item.title}</Card.Title>
                  <Card.Text>
                    <p>{item.desc}</p>
                  </Card.Text>
                </Card.Body>
              </Card>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="home-more-services">
          <Button className="btn-rita" variant="">
            <Link to="/services">More Services</Link>
          </Button>
        </div>
      </Container>

      <Container className="home-cta-section" style={ctaStyle} fluid>
        <div className="home-cta-content">
          <span className="home-cta-badge">Weekly offer</span>
          <h3>10% off braiding, styles & weaves</h3>
          <p>10% off all braiding, styles, weaves and other selected services.</p>
          <Button className="btn-rita" variant="" onClick={() => window.location.href = 'https://takeachair.com/salon-info?salonId=IHi7PDJMLomwaOqeotpm'}>
            {/* <Link to="/appointment">Book Appointment</Link> */}
            Book Appointment
          </Button>
        </div>
      </Container>

      <Container className="home-about-section">
        <Row className="home-about-wrap">
          <Col sm={12} lg={5}>
            <div className="home-about-image-wrap">
              <img src={myimg} alt="Sarah Adom Braiding Salon" />
            </div>
          </Col>
          <Col sm={12} lg={7}>
            <div className="home-about-content p text-justify">
              <h2>WELCOME TO SARAH ADOM BRAIDING SALON</h2>
              <p className="our-text our-desc">
                Welcome to Sarah Adam Braiding Salon, your premier destination for professional African hair braiding in Manassas, Virginia. With a passion for beauty and a commitment to healthy hair care, we specialize in a wide variety of braiding styles that not only enhance your natural beauty but also protect and nourish your hair.
                At Sarah Adam Braiding Salon, we offer a diverse range of styles, including box braids, Senegalese twists, cornrows, crochet braids, goddess braids, and much more. Whether you're looking for a classic, timeless look or something more modern and trendy, our team of skilled braiders will work with you to create the perfect style that suits your personality and lifestyle. Our team of talented stylists and beauty professionals specialize in a wide range of services, from natural hair care and protective styling to extensions, braids, and more.
              </p>
              <Button className="btn-rita app-btn" variant="">
                <Link to="/about">Learn More</Link>
              </Button>
            </div>
          </Col>
        </Row>
      </Container>









      <Container className="home-video-section">
        <div className="home-section-head">
          <span className="section-label">Watch</span>
          <h2 className="our-heading">See our stylists in action</h2>
          <p className="our-desc">Braiding & styling at the salon</p>
        </div>
        <div className="home-video-wrap">
          {FEATURED_VIDEO_ID ? (
            <iframe
              src={`https://www.youtube.com/embed/${FEATURED_VIDEO_ID}?rel=0`}
              title="Sarah Adom Braiding Salon — stylists at work"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="home-video-iframe"
            />
          ) : (
            <div className="home-video-placeholder">
              <p className="home-video-placeholder-text">Feature video</p>
              <p className="home-video-placeholder-hint">Add your YouTube video ID in App.js (FEATURED_VIDEO_ID) to show a braiding or salon video here.</p>
            </div>
          )}
        </div>
      </Container>






      <Container className="home-reviews-section bg-reviews" fluid>
        <div className="home-section-head">
          <span className="section-label">Testimonials</span>
          <h2 className="our-heading">Reviews</h2>
          <p className="our-desc">What our customers are saying</p>
        </div>
        <NewsSlide />
      </Container>

      <Container className="home-gallery-section" fluid>
        <div className="home-section-head">
          <span className="section-label">Portfolio</span>
          <h2 className="our-heading">Recent Work</h2>
          <p className="our-desc">Client looks — perfection at its core</p>
        </div>
        <div className="home-gallery-wrap">
          <Swiper
            spaceBetween={24}
            className="home-gallery-swiper"
            modules={[Navigation, Pagination]}
            pagination={{ clickable: true }}
            breakpoints={{
              0: { slidesPerView: 1 },
              480: { slidesPerView: 2 },
              768: { slidesPerView: 3 },
              992: { slidesPerView: 4 },
              1200: { slidesPerView: 4 },
            }}
          >
            {collections.map((item) => (
              <SwiperSlide key={item.id}>
                <Card className="border-0 home-gallery-card">
                  <div className="home-gallery-card-image">
                    <img src={item.src || salonLogo} alt={item.title || 'Salon work'} />
                  </div>
                  <Card.Body className="home-gallery-card-body">
                    {item.title && <Card.Title>{item.title}</Card.Title>}
                    {item.desc && (
                      <Card.Text as="p" className="home-gallery-card-desc">
                        {item.desc}
                      </Card.Text>
                    )}
                  </Card.Body>
                </Card>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </Container>

      <Container className="home-instagram-section" fluid>
        <div className="home-section-head">
          <span className="section-label">Instagram</span>
          <h2 className="our-heading">Follow Our Latest Looks</h2>
          <p className="our-desc">Fresh braids, styles, and salon moments</p>
        </div>
        <div className="home-instagram-grid">
          {(instagramPosts.length > 0
            ? instagramPosts
            : collections.slice(0, 6).map((item, idx) => ({
                id: item.id || `fallback-${idx}`,
                mediaUrl: item.src || salonLogo,
                permalink: INSTAGRAM_PROFILE_URL,
                caption: item.title || 'Salon style',
              }))
          ).map((item) => (
            <a
              key={item.id}
              href={item.permalink}
              target="_blank"
              rel="noopener noreferrer"
              className="home-instagram-item"
              aria-label="View on Instagram"
            >
              <img src={item.mediaUrl || salonLogo} alt={item.caption || 'Instagram post'} />
            </a>
          ))}
        </div>
        <div className="home-instagram-cta">
          <a href={INSTAGRAM_PROFILE_URL} target="_blank" rel="noopener noreferrer" className="btn-rita">
            Follow us on Instagram
          </a>
        </div>
      </Container>









      

    
    </div>

    </>
  );
}

export default App;
